import MuiTypography, {
    type TypographyProps as MuiTypographyProps,
} from '@mui/material/Typography';
import { type Theme } from '@mui/material';
import { type ElementType, forwardRef } from 'react';
import type { Property } from 'csstype';

const gradientStyles = (gradient: string) => ({
    background: gradient,
    backgroundClip: 'text',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
});

interface OwnProps {
    textTransform?: Property.TextTransform;
    variant?: MuiTypographyProps['variant'];
    component?: ElementType;
    htmlColor?: string | ((theme: Theme) => string);
    gradient?: string;
}

export type TypographyProps = OwnProps & Omit<MuiTypographyProps, 'variant'>;

export const Typography = forwardRef<HTMLElement, TypographyProps>(
    ({ textTransform, variant = 'body2', htmlColor, gradient, sx, ...props }, ref) => {
        return (
            <MuiTypography
                sx={[
                    {
                        textTransform,
                        color: (theme: Theme) => {
                            switch (typeof htmlColor) {
                                case 'string':
                                    return htmlColor;
                                case 'function':
                                    return htmlColor(theme);
                                case 'undefined':
                                    return 'inherit';
                            }
                        },
                        ...(gradient && gradientStyles(gradient)),
                    },
                    ...(Array.isArray(sx) ? sx : [sx]),
                ]}
                variant={variant}
                display="block"
                ref={ref}
                {...props}
            />
        );
    },
);
Typography.displayName = 'Typography';
